import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import moment from "moment";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";
import { axiosInstance } from "../../../helpers/AxiosHelper";
// Auth Related Methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
  getList,
  postFormData,
  postMultipartFormData,
  putImg,
  postEditmultipart,
} from "../../../helpers/Helper";
import {
  apiError,
  advanceBookingListSuccessful,
  advanceBookingByIDSuccessful,
  isModelVisible,
  addadvanceBookingSuccessful,
  isRejectModelVisible,
  getCustomerListSuccessful,
  isCustomerModelVisible,
  personAdd,
  personAddSuccessful,
  getadvanceBookingList,
} from "./advance_booking.slice";

import {
  getadvanceBookingCheckApprove,
  getAdvanceBookingByID,
} from "./advance_booking.slice";

function* getadvanceBookingLists({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          if (k == "start_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else if (k == "end_date") {
            params[k] = moment(data[k]).add(1, "days").format("YYYY-MM-DD");
          } else {
            params[k] = data[k];
          }
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/accounts/advancerequest/",
      params,
    );
    yield put(advanceBookingListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getAdvanceBookingDataByID({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      "/accounts/advancerequest/" + payload.row.id,
      {},
    );
    yield put(advanceBookingByIDSuccessful({ response, type: payload.type }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* addAdvanceBooking({ payload }) {
  try {
    if (payload.id === 0 || payload.id === null || payload.id === undefined) {
      const response = yield call(
        postMultipartFormData,
        "/accounts/advancerequest/",
        payload.formData,
      );
      if (response.status === 201 || response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Advance Booking Added Successfully.!
              </p>
            </div>
          ),
        });
        yield put(isModelVisible(false));
        yield put(addadvanceBookingSuccessful(null));
        yield put(
          getadvanceBookingList({ page: 1, search: "", page_size: 10 }),
        );
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to Do Advance Booking. Please try again!
              </p>
            </div>
          ),
        });
      }
    } else {
      const response = yield call(
        axiosInstance.put,
        "/accounts/advancerequest/" + payload.id,
        payload.formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      if (response.status === 200 || response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Advance Booking Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(isModelVisible(false));
        yield put(addadvanceBookingSuccessful(null));
        yield put(
          getadvanceBookingList({ page: 1, search: "", page_size: 10 }),
        );
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Laon. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
  } catch (error) {
    console.log(error, "LLLLLLLLLLLLLL");
    const backendMessage =
      error?.response?.data?.error?.[0] ||
      error?.message ||
      "Sorry! Getting from server side issue!";

    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">{backendMessage}</p>
        </div>
      ),
    });

    yield put(addadvanceBookingSuccessful(null));
    yield put(apiError(error));
  }
}

function* addCustomerLists({ payload }) {
  try {
    if (payload.id === 0 || payload.id === null || payload.id === undefined) {
      const response = yield call(
        postAdd,
        "/masters/advancerequest/customers/create/",
        payload,
      );
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Customer Details Added Successfully.!
              </p>
            </div>
          ),
        });
        yield put(
          getadvanceBookingList({ page: 1, search: "", page_size: 10 }),
        );
        yield put(isCustomerModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to Do Customer Details. Please try again!
              </p>
            </div>
          ),
        });
      }
    } else {
      const response = yield call(
        postEdit,
        "/masters/advancerequest/customers/create/" + payload.id,
        payload,
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Customer Details Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(personAddSuccessful(null));
        yield put(
          getadvanceBookingList({ page: 1, search: "", page_size: 10 }),
        );
        yield put(isCustomerModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Customer Details. Please try again!
              </p>
            </div>
          ),
        });
      }
      // yield put(vehiclesAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(personAddSuccessful(null));
    yield put(apiError(error));
  }
}

function* AdvanceBookingIdApproval({ payload }) {
  try {
    const response = yield call(
      postEdit,
      "/accounts/advancerequest/approve/" + payload.id,
      payload,
    );

    if (response.status === 200) {
      if (payload.approval_status == 2) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your AdvanceBooking has been approved successfully.
              </p>
            </div>
          ),
        });
      } else if (payload.approval_status == 3) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your AdvanceBooking has been Rejected successfully.
              </p>
            </div>
          ),
        });
      }
      yield put(isRejectModelVisible(false));
      yield put(getadvanceBookingCheckApprove({ id: payload.id }));
      yield put(
        getAdvanceBookingByID({ row: { id: payload.id }, type: "view" }),
      );
    } else {
      if (payload.approval_status == 2) {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to Approve AdvanceBooking. Please try again!
              </p>
            </div>
          ),
        });
      } else if (payload.approval_status == 3) {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to Reject AdvanceBooking. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* VehicleDataGet({ payload }) {
  try {
    const response = yield call(getList, "/masters/vehicles/" + payload, {});
    yield put(vehicleDataSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getCustomerLists({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          if (k == "start_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else if (k == "end_date") {
            params[k] = moment(data[k]).add(1, "days").format("YYYY-MM-DD");
          } else {
            params[k] = data[k];
          }
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/masters/advancerequest/customers/list",
      params,
    );

    yield put(getCustomerListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AdvanceBookingIdDelete({ payload }) {
  try {
    const response = yield call(
      postDelete,
      "/accounts/advancerequest/" + payload.id,
    );

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your AdvanceBooking has been deleted!
            </p>
          </div>
        ),
      });

      yield put(getAdvanceBookingList({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),

        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your AdvanceBooking has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* watchGetadvanceBookingList() {
  yield takeEvery(
    "advanceBooking/getadvanceBookingList",
    getadvanceBookingLists,
  );
}
export function* watchGetAdvanceBookingByID() {
  yield takeEvery(
    "advanceBooking/getAdvanceBookingByID",
    getAdvanceBookingDataByID,
  );
}

export function* watchAddAdvanceBooking() {
  yield takeEvery("advanceBooking/addadvanceBooking", addAdvanceBooking);
}
export function* watchAdvanceBookingDelete() {
  yield takeEvery(
    "advanceBooking/advanceBookingDelete",
    AdvanceBookingIdDelete,
  );
}

export function* watchAdvanceBookingApproval() {
  yield takeEvery(
    "advanceBooking/advanceBookingApproval",
    AdvanceBookingIdApproval,
  );
}

export function* watchGetVehicleData() {
  yield takeEvery("advanceBooking/getVehicleData", VehicleDataGet);
}

export function* watchGetCustomerLists() {
  yield takeEvery("advanceBooking/getCustomerList", getCustomerLists);
}

export function* watchAddCustomerLists() {
  yield takeEvery("advanceBooking/personAdd", addCustomerLists);
}
function* advanceBookingSaga() {
  yield all([
    fork(watchGetadvanceBookingList),
    fork(watchGetAdvanceBookingByID),
    fork(watchAddAdvanceBooking),
    fork(watchAdvanceBookingApproval),
    fork(watchAdvanceBookingDelete),
    fork(watchGetVehicleData),
    fork(watchGetCustomerLists),
    fork(watchAddCustomerLists),
  ]);
}

export default advanceBookingSaga;
